import axios from 'axios';

// --------------------------------------------
// URL CONFIGURATION
// --------------------------------------------
const getBaseURL = () => {
  let base = process.env.REACT_APP_BACKEND_URL || "http://localhost:5001/api";
  base = base.replace(/\/+$/, ""); // Remove trailing slashes
  return base.endsWith("/v1") ? base : `${base}/v1`;
};

const API_URL = getBaseURL();

/**
 * Helper to get token from cookies (as per your existing system)
 */
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const getAuthHeaders = () => {
  const token = getCookie('auth_token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const collegeFormFillApi = {
  // Fetches the logged-in user profile (the MongoDB object you shared)
  getAdminProfile: async () => {
    try {
      // In many systems, /auth/profile or /admin/profile returns current user
      const res = await axios.get(`${API_URL}/auth/profile`, getAuthHeaders());
      return res.data; 
    } catch (error) {
      console.error("Fetch Profile Error:", error);
      return { success: false };
    }
  },

  getCollegeDetails: async (collegeId) => {
    try {
      const res = await axios.get(`${API_URL}/colleges/${collegeId}`, getAuthHeaders());
      return res.data;
    } catch (error) {
      return { success: false };
    }
  }
};

export default collegeFormFillApi;